import * as React from "react";
import { LeftBubble, RightBubble } from "../bubble/Bubble";
import { ConversationContainer } from "./conversationPanelStyles";
import { isTrue } from "common/src/boolean-parser";
import { getBatchAnimationBehavior, renderMessagesInLastBatch, getButtonsDelay } from "./ConversationAnimation";

export const ConversationPanel = props => {
  const initialValues = { lastBatchMessage: "", isGluedBlock: false, glueLength: 0, lastBatchMessages: [] };
  const [state, setStateValues] = props.useState(initialValues);
  const dispatch = props.dispatch;
  let animate = isTrue(window.OPSEEKER_CONFIG.DBOT_ANIMATED);
  let messages = props.messages;
  let actions = props.actions;

  props.useEffect(() => {
    if (!animate) return;
    let animationBehavior = getBatchAnimationBehavior(messages, state);
    if (state.lastBatchMessage !== animationBehavior.lastBatchMessage) {
      setStateValues({ ...animationBehavior });
      dispatch(
        updateButtonsDelay(
          getButtonsDelay(
            animationBehavior.lastBatchMessages.length,
            animationBehavior.isGluedBlock,
            animationBehavior.glueLength
          )
        )
      );
    }
  });

  return (
    <ConversationContainer>
      {(animate ? messages.filter((x, i) => i < messages.length - state.lastBatchMessages.length) : messages).map(
        function(message, index) {
          if (message.side === "left") {
            let withLogo = messages[index + 1] == null || messages[index + 1].side === "right";
            return LeftBubble(
              message,
              withLogo,
              index,
              null,
              actions,
              props.appMode
            );
          }
          return RightBubble(message, index, actions);
        }
      )}
      {animate && renderMessagesInLastBatch(state.lastBatchMessages, state.isGluedBlock, state.glueLength, actions)}
    </ConversationContainer>
  );
};

const updateButtonsDelay = delay => {
  return {
    type: "UPDATE_BUTTONSDELAY",
    payload: delay
  };
};

export default ConversationPanel;
